import type { MonthlyRest, Rest } from '@libs/data-access/entities'
import moment from 'moment'

type Params = {
  rest: Rest | MonthlyRest
  timerange?: { start: string; end: string }
}

const formatFloatNumber = (value: number) => {
  return Number((Math.round(value * 100) / 100).toFixed(1))
}

const getRangeStart = ({ rest, timerange }: Params) => {
  if (!timerange?.start) {
    return rest?.starts_at
  }
  return moment(rest?.starts_at).isBefore(timerange?.start)
    ? timerange?.start
    : rest?.starts_at
}

const getRangeEnd = ({ rest, timerange }: Params) => {
  if (!timerange?.end) {
    return rest?.ends_at
  }
  return moment(rest?.ends_at).isAfter(timerange?.end)
    ? timerange?.end
    : rest?.ends_at
}

export const getRestDurationInDays = ({ rest, timerange }: Params) => {
  const rangeStart = getRangeStart({ rest, timerange })
  const rangeEnd = getRangeEnd({ rest, timerange })

  const rangeFloatDiff = moment(rangeEnd).diff(rangeStart, 'days', true)
  const fullFloatDiff = moment(rest?.ends_at).diff(
    rest?.starts_at,
    'days',
    true
  )

  return {
    fullDuration: formatFloatNumber(fullFloatDiff),
    rangeDuration: formatFloatNumber(rangeFloatDiff)
  }
}
